import { boolean, defineAction, object } from '~/prix'
import systemCheckAction from './monitorStats.action.json' with { type: 'json' }

const systemCheckDefinition = defineAction({
  ...systemCheckAction,

  input: object({}),
  output: object({
    ok: boolean(),
  }),
})

export default systemCheckDefinition
